module.exports = __webpack_public_path__ + "static/protect-iid--store-screenshot-ccce9a97dcb6085d788abbe31527b8b7.png";